import React from 'react';
import { Link } from 'react-router-dom';
import PreferenceCenterLink from '../common/PreferenceCenterLink';
import { Waves } from 'lucide-react';
import { DO_NOT_SELL_OR_SHARE_HREF } from '../../content/legal/privacyNoticeContent';
import { MARKETING_SITE_URL } from '../../config/urls';

const Footer: React.FC = () => {
  return (
    <footer
      className="bg-white border-t border-rowing-gray-200 py-8"
      role="contentinfo"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* Branding */}
          <div className="flex items-start">
            <Link
              to="/"
              className="flex items-center hover:opacity-80 transition-opacity"
              aria-label="Go to home"
            >
              <Waves className="w-7 h-7 text-rowing-blue mr-2" />
              <h3 className="text-xl font-display font-bold text-rowing-navy">GLYYD</h3>
            </Link>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-rowing-gray-900">Product</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={MARKETING_SITE_URL}
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  glyyd.com
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-rowing-gray-900">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-3 text-sm text-rowing-gray-900">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  Privacy Notice
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy/data-subject-request"
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  Data Subject Request
                </Link>
              </li>
              <li>
                <Link
                  to={DO_NOT_SELL_OR_SHARE_HREF}
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  Do Not Sell or Share My Personal Information
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies"
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <PreferenceCenterLink
                  className="text-sm text-rowing-gray-600 hover:text-rowing-blue transition-colors inline-block"
                  text="Consent Preferences"
                />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="mt-6 pt-6 border-t border-rowing-gray-200">
          <div className="text-center">
            <p className="text-xs text-rowing-gray-500">
              &copy; {new Date().getFullYear()} GLYYD. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

export default Footer;
